import React from 'react'
import OnVisible from 'react-on-visible'
import { Section, Image, Link } from 'newComponents'
import { ReactComponent as OrbitCirlces } from '../../images/_background-stars/orbit-circles.svg'
import { ReactComponent as BlurredToggle } from '../../images/_background-stars/blurred-toggle.svg'
import './styles.scss'

const ImageTextCols = (props) => {
  const { data } = props
  const { primary, items } = data
  const { title, tagline } = primary

  // content checks
  const titleHtml = title?.html
  const taglineHtml = tagline?.html
  if (!items) return null

  return (
    <OnVisible className="image-text-cols">
      <Section>
        {/* BACKGROUND SVGS */}
        <OrbitCirlces className="image-text-cols-circles" />
        <BlurredToggle className="image-text-cols-toggle" />
        {taglineHtml && <div className="image-text-cols-tagline" dangerouslySetInnerHTML={{ __html: taglineHtml }} />}
        {titleHtml && <div className="image-text-cols-title" dangerouslySetInnerHTML={{ __html: titleHtml }} />}
        {/* GRID */}
        <div className="image-text-cols-grid">
          {items.map((item) => {
            const { image, content, title: featureTitle, cta_link: ctaLink, cta_text: ctaText } = item
            const contentHtml = content?.html
            const fTitleHtml = featureTitle?.html
            const hasCta = ctaLink?.url && ctaText?.text
            const hasImage = image?.url
            // INDIVIDUAL CARD
            return (
              <div className="image-text-cols-card" key={featureTitle.text}>
                {hasImage && <Image className="image-text-cols-card-image" image={image} />}
                <div className="image-text-cols-card-text">
                  {fTitleHtml && (
                    <div className="image-text-cols-card-title" dangerouslySetInnerHTML={{ __html: fTitleHtml }} />
                  )}
                  {contentHtml && (
                    <div className="image-text-cols-card-content" dangerouslySetInnerHTML={{ __html: contentHtml }} />
                  )}
                  {hasCta && (
                    <Link to={ctaLink.url} className="image-text-cols-card-link" withChevron>
                      {ctaText.text}
                    </Link>
                  )}
                </div>
              </div>
            )
          })}
        </div>
      </Section>
    </OnVisible>
  )
}

export default ImageTextCols
